import { FileText, CreditCard, DollarSign, Clock, ArrowRight } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

const META = {
  po: { label: "Purchase Order", icon: FileText, desc: "Agency pricing applied. Tax-exempt. Invoiced on net terms." },
  cc: { label: "Credit Card (approved)", icon: CreditCard, desc: "Retail pricing + NYC sales tax for this order. Pay via secure Stripe checkout." },
  cash: { label: "Cash (approved)", icon: DollarSign, desc: "Retail pricing + NYC sales tax for this order. Pay in person at delivery / pickup." },
};

export const AgencyPaymentCard = ({ onChange }) => {
  const { paymentChoice, paymentRequest } = useCart();
  const { user } = useAuth();
  const m = META[paymentChoice] || { label: "Credit Card (admin)", icon: CreditCard, desc: "Admin preview at retail pricing." };
  const Icon = m.icon;
  const pending = user?.role === "agency" && paymentRequest?.status === "pending";
  return (
    <div data-testid="agency-payment-method-card" className="rounded-3xl bg-white border border-black/5 p-5 sm:p-6">
      <h2 className="font-display font-black text-[18px] text-brand-charcoal tracking-tight">Payment Method</h2>
      <div className="mt-4 flex items-start gap-3 rounded-2xl border-2 border-brand-teal bg-brand-teal/5 p-4">
        <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-teal text-white">
          <Icon className="h-5 w-5" />
        </span>
        <div className="min-w-0 flex-1">
          <p data-testid="agency-payment-current" className="font-bold text-[14px] text-brand-charcoal leading-tight">{m.label}</p>
          <p className="mt-1 text-[11.5px] text-brand-charcoal/65 leading-snug">{m.desc}</p>
        </div>
      </div>
      {pending && (
        <p data-testid="agency-payment-pending" className="mt-3 flex items-start gap-2 rounded-xl bg-brand-gold/15 px-3 py-2.5 text-[12px] text-brand-gold-dark leading-snug">
          <Clock className="h-4 w-4 shrink-0 mt-0.5" />
          {paymentRequest.method === "cc" ? "Card" : "Cash"} request sent. Prices switch automatically once we approve it.
        </p>
      )}
      <button
        type="button"
        data-testid="agency-payment-change-btn"
        onClick={onChange}
        className="mt-3 inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.12em] text-brand-teal hover:text-brand-charcoal transition-colors"
      >
        Change payment method <ArrowRight className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};
